import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { getStockInfoData } from '../../../../../services/indexApi';
import { rel } from '../../../../../utils/rel';

class StockInfo extends React.PureComponent {
    state = {
        data: [0, 0, 0, 0],
    };

    async componentDidMount() {
        try {
            const data = await getStockInfoData(['s_sh000001']);

            this.setState({
                data: data['s_sh000001'],
            });
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { data } = this.state;

        let styleName = 'blank';

        if (data[3] > 0) {
            styleName = 'red';
        } else if (data[3] < 0) {
            styleName = 'green';
        }

        return (
            <div className={styles.stock_info}>
                <a href="//finance.ifeng.com/app/hq/stock/sh000001/" target="_blank" rel={rel}>
                    上证指数
                </a>
                <p className={`${styles.price} ${styles[styleName]}`}>{data[0]}</p>
                <p className={`${styles.info} ${styles[styleName]}`}>
                    <span>{`${data[2] > 0 ? `+${data[2]}` : data[2]}`} </span>
                    <span>{`${data[3] > 0 ? `+${data[3]}` : data[3]}%`}</span>
                </p>
            </div>
        );
    }
}

export default errorBoundary(StockInfo);
